import React, { useState } from 'react';
import { 
  Avatar, 
  Button, 
  Typography, 
  Card, 
  Progress, 
  Space, 
  Row, 
  Col, 
  Tabs,
  Divider,
  Modal,
  Form,
  Input,
  message
} from 'antd';
import { 
  UserOutlined, 
  HeartOutlined, 
  CommentOutlined, 
  FileTextOutlined,
  SyncOutlined,
  ContactsOutlined,
  InfoCircleOutlined,
  MessageOutlined,
  UsergroupAddOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  GiftOutlined,
  HomeOutlined,
  IdcardOutlined,
  BankOutlined,
  SolutionOutlined,
  CustomerServiceOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import type { TabsProps } from 'antd';

const { Title, Text } = Typography;

// 模拟佣金数据 - 仅用于提现功能
const commissions = [
  {
    id: '1',
    amount: 320,
    status: 'paid',
  },
  {
    id: '2',
    amount: 258,
    status: 'approved',
  },
];

const CustomerProfile: React.FC = () => {
  // 底部导航相关
  const [activeTab, setActiveTab] = useState('3');
  const [withdrawalModalVisible, setWithdrawalModalVisible] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  
  const onTabChange = (key: string) => {
    if (key === 'service') {
      navigate('/mobile-preview/hotel-service');
    } else {
      setActiveTab(key);
    }
  };

  const handleWithdrawalSubmit = () => {
    form.validateFields()
      .then(values => {
        console.log('提现申请:', values);
        setWithdrawalModalVisible(false);
        form.resetFields();
        message.success('提现申请已提交，请等待审核');
      })
      .catch(info => {
        console.log('表单验证失败:', info);
      });
  };

  // 计算可提现佣金
  const availableCommission = commissions
    .filter(item => item.status === 'approved' || item.status === 'paid')
    .reduce((acc, curr) => acc + curr.amount, 0);
  
  const tabItems: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <HomeOutlined />
          <span>预定</span>
        </div>
      )
    },
    {
      key: '2',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <IdcardOutlined />
          <span>会员</span>
        </div>
      )
    },
    {
      key: 'service',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <CustomerServiceOutlined />
          <span>服务</span>
        </div>
      )
    },
    {
      key: '3',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <UserOutlined />
          <span>我的</span>
        </div>
      )
    }
  ];
  
  return (
    <div style={{ 
      maxWidth: 500, 
      margin: '0 auto', 
      background: '#f5f5f5', 
      height: '100vh', 
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      {/* 主内容区 */}
      <div style={{ 
        flex: 1, 
        overflow: 'auto', 
        WebkitOverflowScrolling: 'touch', 
        paddingBottom: 70 
      }}>
        {/* 顶部用户信息区 */}
        <div style={{ 
          padding: '20px', 
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar size={64} icon={<UserOutlined />} style={{ backgroundColor: '#d9d9d9' }} />
            <div style={{ marginLeft: 16 }}>
              <Title level={5} style={{ margin: 0 }}>顾静静</Title>
              <Text type="secondary">欢迎来到秋果酒店</Text>
            </div>
          </div>
          <Button shape="round" icon={<UserOutlined />}>
            编辑
          </Button>
        </div>
        
        {/* 会员卡片区域 */}
        <Card style={{ 
          margin: '16px', 
          borderRadius: 8, 
          background: 'linear-gradient(to right, #20232a, #1e2126)'
        }}>
          <div style={{ color: '#fff', marginBottom: 8 }}>
            <Title level={4} style={{ color: '#fff', margin: 0 }}>普卡</Title>
            <Text style={{ color: '#ccc' }}>可以升至银卡会员</Text>
          </div>
          <Progress 
            percent={30} 
            showInfo={false} 
            strokeColor="#f0c755" 
            trailColor="rgba(255,255,255,0.2)" 
            style={{ marginBottom: 16 }}
          />
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            padding: '10px 0', 
            background: 'rgba(255,255,255,0.1)',
            borderRadius: 4
          }}>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <div style={{ color: '#ccc' }}>9.5<small>折</small></div>
              <div style={{ color: '#aaa', fontSize: 12 }}>房费折扣</div>
            </div>
            <Divider type="vertical" style={{ height: 40, background: 'rgba(255,255,255,0.1)' }} />
            <div style={{ textAlign: 'center', flex: 1 }}>
              <div style={{ color: '#ccc' }}>13:00</div>
              <div style={{ color: '#aaa', fontSize: 12 }}>延迟退房</div>
            </div>
            <Divider type="vertical" style={{ height: 40, background: 'rgba(255,255,255,0.1)' }} />
            <div style={{ textAlign: 'center', flex: 1 }}>
              <div style={{ color: '#ccc' }}>···</div>
              <div style={{ color: '#aaa', fontSize: 12 }}>更多</div>
            </div>
          </div>
        </Card>
        
        {/* 快捷入口区域 */}
        <Card style={{ margin: '16px', borderRadius: 8 }}>
          <Row gutter={16} justify="space-around" style={{ textAlign: 'center' }}>
            <Col span={6}>
              <div style={{ padding: '10px 0' }}>
                <div style={{ 
                  width: 50, 
                  height: 50, 
                  margin: '0 auto', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: 'rgba(99, 156, 254, 0.2)',
                  borderRadius: '50%'
                }}>
                  <i className="icon" style={{ fontSize: 28, color: '#639cfe' }}>🏨</i>
                </div>
                <div style={{ marginTop: 8 }}>酒店订单</div>
              </div>
            </Col>
            <Col span={6}>
              <div style={{ padding: '10px 0' }}>
                <div style={{ 
                  width: 50, 
                  height: 50, 
                  margin: '0 auto', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: 'rgba(254, 132, 132, 0.2)',
                  borderRadius: '50%'
                }}>
                  <i className="icon" style={{ fontSize: 28, color: '#fe8484' }}>🛒</i>
                </div>
                <div style={{ marginTop: 8 }}>商城订单</div>
              </div>
            </Col>
            <Col span={6}>
              <div style={{ padding: '10px 0' }}>
                <div style={{ 
                  width: 50, 
                  height: 50, 
                  margin: '0 auto', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: 'rgba(130, 219, 175, 0.2)',
                  borderRadius: '50%'
                }}>
                  <i className="icon" style={{ fontSize: 28, color: '#82dbaf' }}>💎</i>
                </div>
                <div style={{ marginTop: 8 }}>会员权益</div>
              </div>
            </Col>
            <Col span={6}>
              <div style={{ padding: '10px 0' }}>
                <div style={{ 
                  width: 50, 
                  height: 50, 
                  margin: '0 auto', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: 'rgba(248, 203, 98, 0.2)',
                  borderRadius: '50%'
                }}>
                  <i className="icon" style={{ fontSize: 28, color: '#f8cb62' }}>💰</i>
                </div>
                <div style={{ marginTop: 8 }}>积分兑换</div>
              </div>
            </Col>
          </Row>
        </Card>
        
        {/* 账户信息区域 */}
        <Card style={{ margin: '16px', borderRadius: 8 }}>
          <Row justify="space-between" align="middle">
            <Col span={8} style={{ textAlign: 'center', borderRight: '1px solid #f0f0f0' }}>
              <div style={{ color: '#529C8A', fontSize: 20, fontWeight: 'bold' }}>¥ 9</div>
              <div style={{ color: '#666', fontSize: 14 }}>余额</div>
            </Col>
            <Col span={8} style={{ textAlign: 'center', borderRight: '1px solid #f0f0f0' }}>
              <div style={{ color: '#529C8A', fontSize: 20, fontWeight: 'bold' }}>0</div>
              <div style={{ color: '#666', fontSize: 14 }}>券包</div>
            </Col>
            <Col span={8} style={{ textAlign: 'center' }}>
              <div style={{ color: '#529C8A', fontSize: 20, fontWeight: 'bold' }}>101</div>
              <div style={{ color: '#666', fontSize: 14 }}>积分</div>
            </Col>
          </Row>
        </Card>
        
        {/* 常用功能区域 */}
        <Card style={{ margin: '16px', borderRadius: 8 }}>
          <Title level={5} style={{ marginBottom: 16 }}>常用功能</Title>
          <Row gutter={[16, 24]}>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<HeartOutlined />} />
                <div style={{ marginTop: 8 }}>收藏酒店</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<CommentOutlined />} />
                <div style={{ marginTop: 8 }}>酒店点评</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<FileTextOutlined />} />
                <div style={{ marginTop: 8 }}>发票信息</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<SyncOutlined />} />
                <div style={{ marginTop: 8 }}>兑换中心</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<ContactsOutlined />} />
                <div style={{ marginTop: 8 }}>通讯录</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<InfoCircleOutlined />} />
                <div style={{ marginTop: 8 }}>关于我们</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<MessageOutlined />} />
                <div style={{ marginTop: 8 }}>反馈意见</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div style={{ cursor: 'pointer' }} onClick={() => navigate('/mobile-preview/my-butler')}>
                <Avatar size={40} icon={<UserOutlined />} style={{ backgroundColor: '#529C8A' }} />
                <div style={{ marginTop: 8 }}>我的管家</div>
              </div>
            </Col>
          </Row>
        </Card>
        
        {/* 门店常用区域 */}
        <Card style={{ margin: '16px', borderRadius: 8 }}>
          <Title level={5} style={{ marginBottom: 16 }}>门店常用</Title>
          <Row gutter={[16, 16]}>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<UsergroupAddOutlined />} />
                <div style={{ marginTop: 8 }}>拉新</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<DollarOutlined />} onClick={() => setWithdrawalModalVisible(true)} style={{ cursor: 'pointer' }} />
                <div style={{ marginTop: 8 }}>提现</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<EnvironmentOutlined />} />
                <div style={{ marginTop: 8 }}>位置</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center' }}>
              <div>
                <Avatar size={40} icon={<GiftOutlined />} />
                <div style={{ marginTop: 8 }}>活动</div>
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'center', marginTop: 16 }}>
              <div onClick={() => navigate('/mobile-preview/promotion')} style={{ cursor: 'pointer' }}>
                <Avatar size={40} icon={<SolutionOutlined />} style={{ backgroundColor: '#1890ff' }} />
                <div style={{ marginTop: 8 }}>员工推广</div>
              </div>
            </Col>
          </Row>
        </Card>
      </div>
      
      {/* 底部导航栏 */}
      <div style={{ 
        position: 'fixed', 
        bottom: 0, 
        width: '100%', 
        maxWidth: 500, 
        zIndex: 10,
        background: '#fff',
        borderTop: '1px solid #f0f0f0'
      }}>
        <Tabs
          activeKey={activeTab}
          onChange={onTabChange}
          centered
          items={tabItems}
          tabBarStyle={{ 
            height: 60,
            margin: 0
          }}
        />
      </div>

      {/* 提现弹窗 */}
      <Modal 
        title="申请提现" 
        open={withdrawalModalVisible}
        onCancel={() => setWithdrawalModalVisible(false)}
        onOk={handleWithdrawalSubmit}
        okText="提交"
        cancelText="取消"
        okButtonProps={{ style: { backgroundColor: '#529C8A', borderColor: '#529C8A' } }}
      >
        <Form 
          form={form}
          layout="vertical"
        >
          <Form.Item>
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <Text>可提现金额: </Text>
              <Text strong style={{ fontSize: 20, color: '#529C8A' }}>¥{availableCommission.toFixed(2)}</Text>
            </div>
          </Form.Item>
          <Form.Item
            name="amount"
            label="提现金额"
            rules={[
              { required: true, message: '请输入提现金额' },
              { 
                validator: (_, value) => {
                  if (value && Number(value) > availableCommission) {
                    return Promise.reject('提现金额不能大于可提现金额');
                  }
                  return Promise.resolve();
                }
              }
            ]}
          >
            <Input prefix="￥" suffix="元" placeholder="请输入提现金额" />
          </Form.Item>
          <Form.Item
            name="bank"
            label="银行账户"
            rules={[{ required: true, message: '请输入银行账户' }]}
          >
            <Input placeholder="请输入银行账户" prefix={<BankOutlined />} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default CustomerProfile; 